// extracted by mini-css-extract-plugin
export default {"blogContainer":"style_blogContainer__ThA2n","blogInnerBlock":"style_blogInnerBlock__wqBCD"};